import { namespace } from 'vuex-class'
import { Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { RawLocation } from 'vue-router'
// import { VuetifyBreakpoint } from 'vuetify/types/services/breakpoint'
import find from 'lodash/find'

const _namespace = 'product'
export const StateProduct = namespace(_namespace).State
export const GetterProduct = namespace(_namespace).Getter
export const MutationProduct = namespace(_namespace).Mutation
export const ActionProduct = namespace(_namespace).Action

export interface ProductItem {
  name: string
  titre: string
  description: string | null
  image: string
  tag: number
  colors: any[] | null
  prixOld: number | null
  prix: number | null
  reduction: number | null
  quantite: number
  stock: number | null
  buy: boolean
  icon: string | null
  iconColor: string | null
  link: string | null
  images: any[] | null
}

export interface ProductState {
  // productSport: ProductItem[]
  // productTextile: ProductItem[]
  // productRevetement: ProductItem[]
  // productBois: ProductItem[]
  // productBalle: ProductItem[]
  // productAccessoire: ProductItem[]
  // productChaussure: ProductItem[]
  productAll: ProductItem[] | null
}

@Module({ namespaced: true, name: _namespace })
export default class ProductModule extends VuexModule implements ProductState {
  // breakpoint: VuetifyBreakpoint | null = null

  items: ProductItem[] = [
    {
      name: 'amicus_prime',
      titre: 'Amicus Prime',
      description: '1h de robot avec les balles',
      image: 'amicus-prime_1.jpg',
      tag: 1,
      colors: null,
      prixOld: null,
      prix: 15,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: null,
      images: []
    },
    {
      name: 'cours-individuel',
      titre: 'Cours individuel',
      description: '1h d\'entraînement individuel avec un éducateur spécialisé',
      image: 'training.jpg',
      tag: 1,
      colors: null,
      prixOld: null,
      prix: 30,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: null,
      images: []
    },
    {
      name: 'maillot_club',
      titre: 'Maillot Club',
      description: 'Maillot obligatoire en compétition par équipes',
      image: 'xero.png',
      tag: 2,
      colors: null,
      prixOld: 29.90,
      prix: 22,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: null,
      images: []
    },
    {
      name: 'polo-tori',
      titre: 'Polo Tori',
      description: 'Avec la matière Micro DryFit, ...',
      image: 'tori/shirt_tori_black_front.jpg',
      tag: 2,
      colors: [{ color: '#000' }, { color: '#1E88E5' }, { color: '#F44336' }],
      prixOld: 39.90,
      prix: 34,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/polo-tori.html',
      images: [{ src: 'tori/shirt_tori_black_front.jpg' }, { src: 'tori/shirt_tori_blue_front.jpg' }, { src: 'tori/shirt_tori_red_front.jpg' }]
    },
    {
      name: 'polo-tori-lady',
      titre: 'Polo Tori Lady',
      description: 'Coupe cintrée pour les femmes',
      image: 'tori/shirt_tori_lady_magenta_front.jpg',
      tag: 2,
      colors: [{ color: '#000' }, { color: '#1E88E5' }, { color: '#FF00FF' }],
      prixOld: 39.90,
      prix: 34,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/polo-tori-lady.html',
      images: [{ src: 'tori/shirt_tori_lady_magenta_front.jpg' }, { src: 'tori/shirt_tori_lady_blue_front.jpg' }, { src: 'tori/shirt_tori_lady_black_front.jpg' }]
    },
    {
      name: 'polo-kisa',
      titre: 'Polo Kisa',
      description: 'Matière innovante pour crée une sensation de liberté. Couleurs : vert, bleu glace, bleu azure, rouge',
      image: 'kisa/shirt_kisa_red_front_1.jpg',
      tag: 2,
      colors: [{ color: '#000' }, { color: '#F44336' }, { color: '#1E88E5' }],
      prixOld: 36.90,
      prix: 32,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/polo-kisa.html',
      images: [{ src: 'kisa/shirt_kisa_blue_front.jpg' }, { src: 'kisa/shirt_kisa_azur_blue_back.jpg' }, { src: 'kisa/shirt_kisa_azur_blue_front.jpg' }, { src: 'kisa/shirt_kisa_red_front_1.jpg' }, { src: 'kisa/shirt_kisa_green_front.jpg' }]
    },
    {
      name: 'polo-kisa',
      titre: 'SHORT KIHON',
      description: 'Short long décontraté',
      image: 'kihon/shorts_kihon_grey_front.jpg',
      tag: 2,
      colors: [{ color: '#CCC' }, { color: '#0e0859' }],
      prixOld: 36.90,
      prix: 32,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/short-kihon.html',
      images: [{ src: 'kihon/shorts_kihon_grey_front.jpg' }, { src: 'kihon/shorts_kihon_navy_front.jpg' }]
    },
    {
      name: 'serviette-mid-yao',
      titre: 'Serviette Midi Yao',
      description: 'Serviette 100% coton',
      image: 'serviettes/towel_20yao_20midi_preview.jpeg',
      tag: 2,
      colors: [{ color: '#000' }, { color: '#F06292' }],
      prixOld: 9.90,
      prix: 8,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/serviette-mid-yao.html',
      images: [{ src: 'serviettes/towel_20yao_20midi_preview.jpeg' }, { src: 'serviettes/towel_20yao_20big_preview.jpeg' }]
    },
    {
      name: 'serviette-stripe',
      titre: 'SERVIETTE STRIPE',
      description: 'Serviette astucieuse avec un aimant intégré pour fixation sur du métal',
      image: 'serviettes/towel_20yao_20midi_preview.jpeg',
      tag: 2,
      colors: [{ color: '#1E88E5' }, { color: '#000' }, { color: '#F44336' }],
      prixOld: 15.90,
      prix: 13.5,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: 'heart',
      iconColor: 'pink',
      link: 'https://fr.butterfly.tt/textiles/serviettes/serviette-stripe.html',
      images: [{ src: 'serviettes/towels_20stripe_preview_1.jpeg' }, { src: 'serviettes/towels_20stripe_20-_20magnet_preview_1.jpeg' }]
    },
    {
      name: 'serviette-germany-18',
      titre: 'Serviette Germany',
      description: 'Pour les fans de l\'équipe d\'Allemagne',
      image: 'serviettes/towel_germany.jpg',
      tag: 2,
      colors: null,
      prixOld: 12.90,
      prix: 11,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/serviette-germany-18.html',
      images: []
    },
    {
      name: 'textiles_autres',
      titre: 'les autres',
      description: '',
      image: '4yasu_1.png',
      tag: 2,
      colors: null,
      prixOld: null,
      prix: null,
      reduction: 15,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: null,
      images: []
    },
    // REVETEMENTS
    {
      name: 'tenergy',
      titre: 'Tenergy',
      description: 'Précision Optimale. Couleurs : noir ou rouge',
      image: 'revetement/tenergy.jpg',
      tag: 3,
      colors: [{ color: '#000' }, { color: '#F44336' }],
      prixOld: null,
      prix: 59.90,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/catalogsearch/result/?q=tenergy',
      images: [{ src: 'revetement/tenergy.jpg' }, { src: 'revetement/tenergy.jpg' }]
    },
    {
      name: 'dignics-05',
      titre: 'Dignics 05',
      description: 'levez votre niveau de jeu. Couleurs : noir ou rouge',
      image: 'revetement/revetement-butterfly-dignics-05.jpg',
      tag: 3,
      colors: [{ color: '#000' }, { color: '#F44336' }],
      prixOld: null,
      prix: 79.90,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/dignics-05.html',
      images: []
    },
    {
      name: 'impartial-xb',
      titre: 'IMPARTIAL XB',
      description: 'Nouveau',
      image: 'revetement/impartialxb.png',
      tag: 3,
      colors: [{ color: '#000' }, { color: '#F44336' }],
      prixOld: 49.90,
      prix: 45,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: 'new-box',
      iconColor: 'amber',
      link: 'https://fr.butterfly.tt/impartial-xb.html',
      images: []
    },
    {
      name: 'impartial-xs',
      titre: 'IMPARTIAL XS',
      description: 'Nouveau',
      image: 'revetement/impartialxs.png',
      tag: 3,
      colors: [{ color: '#000' }, { color: '#F44336' }],
      prixOld: 49.90,
      prix: 45,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: 'new-box',
      iconColor: 'amber',
      link: 'https://fr.butterfly.tt/impartial-xs.html',
      images: []
    },
    {
      name: 'revetements_autres',
      titre: 'Les autres',
      description: '... Couleurs : noir ou rouge',
      image: 'revetement/belagseite-750x400.jpg',
      tag: 3,
      colors: [{ color: '#000' }, { color: '#F44336' }],
      prixOld: null,
      prix: null,
      reduction: 10,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/dignics-05.html',
      images: []
    },
    // BOIS
    {
      name: 'timo-boll-j',
      titre: 'Timo Boll J',
      description: 'Bien débuter',
      image: 'bois/blade_timo_boll_j_fl.jpg',
      tag: 4,
      colors: null,
      prixOld: 59.90,
      prix: 54,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/timo-boll-j.html',
      images: []
    },
    {
      name: 'sk-carbon',
      titre: 'Sk Carbon',
      description: 'Bois léger en carbone avec plus de toucher',
      image: 'bois/sk_carbon.png',
      tag: 4,
      colors: null,
      prixOld: 99.90,
      prix: 90,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/sk-carbon.html',
      images: []
    },
    {
      name: 'diode-v',
      titre: 'DIODE V',
      description: 'bois défensif',
      image: 'bois/36961_diode_v-fl_04.jpg',
      tag: 4,
      colors: null,
      prixOld: 79.90,
      prix: 72,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/diode-v.html',
      images: []
    },
    {
      name: 'balles-g40-pvc',
      titre: 'Butterfly S40+',
      description: 'Rondeur parfaite et épaisseur identique.',
      image: 's40_1.jpg',
      tag: 5,
      colors: null,
      prixOld: null,
      prix: 5.90,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/balles/balles-g40-pvc.html',
      images: []
    },
    {
      name: 'tour-de-raquette-bleu-argent',
      titre: 'TOUR DE RAQUETTE BLEU / ARGENT',
      description: 'Le tour de raquette bleu et argent.',
      image: 'accessoire/butterfly_racket_care_side_tapes_4_1.png',
      tag: 6,
      colors: null,
      prixOld: 6.90,
      prix: 6,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/accessoires/tours-de-raquette/tour-de-raquette-bleu-argent.html',
      images: []
    },
    {
      name: 'tour-de-raquette-tenergy',
      titre: 'TOUR DE RAQUETTE TENERGY',
      description: 'Le tour de raquette Tenergy. 12MM / 10M',
      image: 'accessoire/butterfly_zubehoer_kantenband_tenergy_1.png',
      tag: 6,
      colors: null,
      prixOld: 6.90,
      prix: 6,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null, iconColor: null,
      link: 'https://fr.butterfly.tt/accessoires/tours-de-raquette/tour-de-raquette-tenergy.html',
      images: []
    },
    {
      name: 'armband-silikon',
      titre: 'Bracelet Silicon',
      description: null,
      image: 'accessoire/bracelet_silikon.jpg',
      tag: 6,
      colors: [{ color: '#000' }, { color: '#F06292' }],
      prixOld: 2,
      prix: 1.86,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/accessoires/armband-silikon.html',
      images: []
    },
    {
      name: 'lezoline-rifones',
      titre: 'LEZOLINE RIFONES',
      description: 'LEZOLINE RIFONES la performance.',
      image: 'chaussure/shoes_rifones_magenta_lime_navy.jpg',
      tag: 7,
      colors: [{ color: '#F06292' }, { color: '#CCFF90' }, { color: '#2196F3' }],
      prixOld: 119.90,
      prix: 100,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/lezoline-rifones.html',
      images: [{ src: 'chaussure/shoes_rifones_magenta_lime_navy.jpg' }, { src: 'chaussure/shoes_rifones_lime_side.jpg' }, { src: 'chaussure/shoes_rifones_navy_front.jpg' }, { src: 'chaussure/shoes_rifones_magenta_side.jpg' }, { src: 'chaussure/shoes_rifones_navy_sole.jpg' }, { src: 'chaussure/shoes_rifones_navy_upper.jpg' }]
    },
    {
      name: 'lezoline-zero',
      titre: 'LEZOLINE ZERO',
      description: 'Spécialement conçue pour le tennis de table.',
      image: 'chaussure/zero.png',
      tag: 7,
      colors: null,
      prixOld: 59.90,
      prix: 50,
      reduction: null,
      quantite: 1,
      stock: null,
      buy: false,
      icon: null,iconColor: null,
      link: 'https://fr.butterfly.tt/lezoline-zero.html',
      images: []
    }
  ]

  get productAll (): ProductItem[] {
    return this.items
  }
}
